import { useMemo, useCallback } from 'react';
import { useAppInventory } from './useAppInventory';

export const useAppIconLookup = () => {
  const { inventory } = useAppInventory();
  
  // Create a lookup map from app name to icon
  const iconMap = useMemo(() => {
    const map = new Map<string, string>();
    inventory.forEach(app => {
      if (app.icon) {
        // Store by exact name (case insensitive)
        map.set(app.name.toLowerCase(), app.icon);
        
        // Also store by bundle ID last component (e.g., "com.apple.Safari" -> "safari")
        const bundleLastPart = app.bundle_id.split('.').pop();
        if (bundleLastPart) {
          map.set(bundleLastPart.toLowerCase(), app.icon);
        }
      }
    });
    return map;
  }, [inventory]);
  
  const getAppIcon = useCallback((updateName: string): string | null => {
    if (!updateName) return null;
    
    const lowerUpdateName = updateName.toLowerCase();
    
    // Try exact match first
    for (const [appName, icon] of iconMap.entries()) {
      if (lowerUpdateName.includes(appName)) {
        return icon;
      }
    }
    
    return null;
  }, [iconMap]);
  
  return { getAppIcon };
};
